import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { useEffect } from 'react'

import { Banner } from 'slab'

import { useCardPayment } from '../CardPaymentProvider'
import useCreateStripePaymentMethod from '../useCreateStripePaymentMethod'

export default function StripePaymentForm () {
  const stripe = useStripe()
  const elements = useElements()

  const { setIsCreatingPaymentMethod, registerCreatePaymentMethod } = useCardPayment()

  const { isLoading, errorMessage, createPaymentMethod } = useCreateStripePaymentMethod({ stripe, elements })

  useEffect(() => {
    setIsCreatingPaymentMethod(isLoading)
  }, [isLoading, setIsCreatingPaymentMethod])

  useEffect(() => {
    registerCreatePaymentMethod(createPaymentMethod)
  }, [createPaymentMethod, registerCreatePaymentMethod])

  return (
    <div className='flex flex-col gap-4'>
      <PaymentElement
        options={{
          layout: 'tabs',
          wallets: {
            link: 'never',
          },
          terms: {
            card: 'never',
          }
        }}
      />

      <div className='body-sm text-gray-500 px-2'>
        By providing your card information, you allow Thatch to charge your card for future payments in accordance with its terms.
      </div>

      {errorMessage && (
        <Banner type='critical' title={errorMessage} />
      )}
    </div>
  )
}
